export default __webpack_public_path__ + "static/media/candidateManagementIcon2.7fb60d9a.svg";